/**
 * v1.0 Sprint 3 — Homepage-Banner „Wertungsupdate v1.0"
 *
 * Wird 14 Tage ab 2026-06-11 angezeigt (bis 2026-06-25). Danach automatisch
 * ausgeblendet. localStorage merkt sich Dismiss damit Pilot ihn nicht zweimal
 * weg-klicken muss.
 */

'use client'

import { useEffect, useState } from 'react'

const BANNER_START = new Date('2026-06-11T00:00:00Z').getTime()
const BANNER_END = new Date('2026-06-25T00:00:00Z').getTime()
const DISMISS_KEY = 'fgl-v1-0-banner-dismissed'

export function FglV1_0UpdateBanner() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const now = Date.now()
    if (now < BANNER_START || now > BANNER_END) return
    if (typeof window !== 'undefined' && window.localStorage?.getItem(DISMISS_KEY) === '1') return
    setVisible(true)
  }, [])

  function dismiss() {
    try {
      window.localStorage?.setItem(DISMISS_KEY, '1')
    } catch {}
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div className="relative border-y-2 border-amber-500/40 bg-gradient-to-r from-amber-50 via-amber-100 to-amber-50 px-4 py-3 dark:from-amber-950/40 dark:via-amber-900/40 dark:to-amber-950/40">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4">
        <div className="flex items-start gap-3">
          <span className="mt-0.5 text-2xl" aria-hidden>⚙</span>
          <div className="flex-1">
            <p className="text-sm font-semibold text-amber-900 dark:text-amber-200">
              FGL Scoring Engine v1.0 — Wertungsupdate aktiv
            </p>
            <p className="mt-0.5 text-xs text-amber-800 dark:text-amber-300/80">
              Die Wertungslogik wurde komplett überarbeitet. Manche deiner Flüge können neu berechnet worden sein.
              {' '}
              <a href="/faq" className="font-semibold underline hover:text-amber-900 dark:hover:text-amber-100">
                Mehr Infos
              </a>
            </p>
          </div>
        </div>
        <button
          onClick={dismiss}
          className="shrink-0 rounded-md border border-amber-600/40 bg-white/60 px-3 py-1 text-xs font-semibold text-amber-900 hover:bg-white dark:bg-amber-900/40 dark:text-amber-200"
          aria-label="Banner schließen"
        >
          Verstanden ✕
        </button>
      </div>
    </div>
  )
}
